import { createContext, ReactNode, useReducer } from 'react';
import { NotificationModel } from '../../components/AccountNotifications';

export interface INotificationContextAction {
  type: 'ADD' | 'REMOVE';
  payload?: NotificationModel;
}

export function NotificationContextReducer(state: NotificationModel[], action: INotificationContextAction) {
  switch (action.type) {
    case 'ADD':
      return [action.payload, ...state];
    case 'REMOVE':
      return [...state.filter((x) => x.id !== action.payload.id)];
  }
}

const initialState: NotificationModel[] = [];

const NotificationContext = createContext<{
  state: typeof initialState;
  dispatch: (action: INotificationContextAction) => void;
}>({
  state: initialState,
  dispatch: () => {}
});

const NotificationContextProvider: React.FC<{ children: ReactNode }> = (props) => {
  const [state, dispatch] = useReducer(NotificationContextReducer, [...initialState]);
  const value = { state, dispatch };
  return <NotificationContext.Provider value={value}>{props.children}</NotificationContext.Provider>;
};

const ContextConsumer = NotificationContext.Consumer;

export { NotificationContext, NotificationContextProvider, ContextConsumer };
